<template>
  <div>

    <!-- 🔹 Header Row -->
    <div class="header-row"
      style="display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap;
            gap:12px; margin:0 .5rem 1.5rem .5rem;">

      <h1 class="page-title"
        style="display:flex; align-items:center; gap:8px; font-size:1.2rem; font-weight:700;
               color:var(--text); margin:0;">
        <i class="bx bx-credit-card" style="font-size:1.4rem; color:var(--primary);"></i>
        Payment Overview
      </h1>

      <div class="filters" style="display:flex; align-items:center; gap:10px; flex-wrap:wrap;">

        <!-- 📅 Date Range -->
        <select v-model="selectedRange" class="select-theme">
          <option value="today">Today</option>
          <option value="last_7_days">Last 7 Days</option>
          <option value="last_30_days">Last 30 Days</option>
          <option value="last_12_months">Last 12 Months</option>
        </select>

        <!-- 🌐 Payment Source -->
        <select v-model="selectedSource" class="select-theme">
          <option value="all">All Sources</option>
          <option value="page">Page</option>
          <option value="booking_pages">Booking Pages</option>
          <option value="invoice">Invoice</option>
        </select>

        <!-- 💰 Payment Status -->
        <select v-model="selectedStatus" class="select-theme">
          <option value="all">All Status</option>
          <option value="completed">Completed</option>
          <option value="pending">Pending</option>
          <option value="refunded">Refunded</option>
        </select>

        <!-- 🔍 Apply Filters -->
        <button class="btn-primary" @click="fetchPaymentData">
          <i class="bx bx-search"></i> Search
        </button>

      </div>
    </div>

    <!-- === KPI Cards === -->
    <div class="kpi-row fade-in">
      <div v-for="(kpi, i) in kpis" :key="'kpi-'+i" class="kpi-card">
        <div>
          <h4>{{ kpi.label }}</h4>
          <div class="value">{{ kpi.value }}</div>
        </div>
        <i :class="kpi.icon + ' kpi-icon'"></i>
      </div>
    </div>

    <!-- === CTA Card === -->
    <div class="cta-card">
      <div class="cta-content">
        <div class="cta-text">
          <h2>💳 Track All Payments & Sources</h2>
          <p>
            All your hard-earned payments are gathered in one clean view so you can focus on creating.
          </p>
        </div>
        <div class="cta-action">
          <button class="cta-btn" @click="gotoinvoice()">
            <i class="bx bx-line-chart"></i>
            Start Collecting Payments
          </button>
        </div>
      </div>
    </div>

    <!-- === Charts Section === -->
    <div class="charts-row">

      <!-- 🔹 Revenue Chart -->
      <div class="chart-box">
        <h4>Total Revenue</h4>

        <div v-if="!loading && chartData.isRevenue" id="revenueChart" class="chart-placeholder"></div>

        <div v-else class="empty-chart-placeholder">
          <i class="bx bx-line-chart"></i>
          <p>No revenue data yet</p>
        </div>
      </div>

      <!-- 🔹 Source Chart -->
      <div class="chart-box">
        <h4>Payment Source Distribution</h4>

        <div v-if="!loading && chartData.isSource" id="sourceChart" class="chart-placeholder"></div>

        <div v-else class="empty-chart-placeholder">
          <i class="bx bx-doughnut-chart"></i>
          <p>No source data available</p>
        </div>
      </div>

      <!-- 🔹 Status Chart -->
      <div class="chart-box">
        <h4>Payment Status Overview</h4>

        <div v-if="!loading && chartData.isStatus" id="statusChart" class="chart-placeholder"></div>

        <div v-else class="empty-chart-placeholder">
          <i class="bx bx-bar-chart-alt"></i>
          <p>No status insights</p>
        </div>
      </div>

      <!-- 🔹 Trend Chart -->
      <div class="chart-box">
        <h4>Weekly Comparison (AI Trend)</h4>

        <div v-if="!loading && chartData.istrend" id="trendChart" class="chart-placeholder"></div>

        <div v-else class="empty-chart-placeholder">
          <i class="bx bx-trending-up"></i>
          <p>AI trend data not available yet</p>
        </div>
      </div>

    </div>

    <!-- === Transactions Table === -->
    <div class="table-box">

      <div class="table-header">
        <h4>Recent Transactions</h4>

        <div>
          <select v-model="filter">
            <option value="all">All</option>
            <option value="completed">Completed</option>
            <option value="pending">Pending</option>
          </select>

          &nbsp;&nbsp;

          <button class="btn-primary" @click="downPaymentData">
            <i class="bx bx-download"></i> Download
          </button>
        </div>
      </div>

      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Source</th>
            <th>Customer</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Reference</th>
          </tr>
        </thead>

        <tbody v-if="filteredTransactions.length">
          <tr v-for="tx in paginatedTransactions" :key="tx.reference">
            <td>{{ tx.date }}</td>
            <td>{{ tx.source }}</td>
            <td>{{ tx.customer }}</td>
            <td>{{ tx.amount }}</td>
            <td>
              <span :style="tx.status === 'Completed' ? 'color:green' : 'color:#92400E'">
                {{ tx.status }}
              </span>
            </td>
            <td>{{ tx.reference }}</td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr>
            <td colspan="6">
              <div class="empty-state">
                <i class="bx bx-wallet"></i>
                <h3>No Transactions Found</h3>
                <p>Your payment history will appear here once you start receiving payments.</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Pagination -->
      <div class="pagination">
        <span>Page {{ page }}</span>

        <div>
          <button @click="prevPage" :disabled="page===1">
            <i class='bx bx-chevron-left'></i>
          </button>

          <button @click="nextPage" :disabled="endIndex>=filteredTransactions.length">
            <i class='bx bx-chevron-right'></i>
          </button>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
import ApexCharts from "apexcharts";
import { useToast } from "vue-toastification";
import { getPaymentReport, downPaymentReport } from "@/apis/paymentapis";

const CHART_COLORS = {
  primary: "#111827",
  secondary: "#1f2937",
  tertiary: "#374151",
  muted: "#6b7280",
};

export default {
  name: "PaymentDashboard",

  data() {
    return {
      toast: useToast(),
      userId: "",
      loading: false,

      selectedRange: "last_7_days",
      selectedSource: "all",
      selectedStatus: "all",

      filter: "all",

      page: 1,
      perPage: 4,

      kpis: [],

      chartData: {
        revenue: [],
        sources: [],
        status: [],
        trend: [],
        isRevenue: false,
        isSource: false,
        isStatus: false,
        istrend: false,
      },

      transactions: [],
    };
  },

  computed: {
    filteredTransactions() {
      if (this.filter === "all") return this.transactions;

      return this.transactions.filter(
        (tx) => tx.status.toLowerCase() === this.filter
      );
    },

    paginatedTransactions() {
      const start = (this.page - 1) * this.perPage;
      return this.filteredTransactions.slice(start, start + this.perPage);
    },

    endIndex() {
      return this.page * this.perPage;
    },
  },

  mounted() {
    const ldataRaw = sessionStorage.getItem("ldata");
    const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;

    if (!ldata) {
      window.location.href = "/login";
      return;
    }

    this.userId = ldata.user_id;
    this.fetchPaymentData();
  },

  methods: {
    nextPage() {
      if (this.endIndex < this.filteredTransactions.length) this.page++;
    },

    prevPage() {
      if (this.page > 1) this.page--;
    },

    gotoinvoice() {
      window.location.href = "/invoices";
    },

    isEmptyOrZero(arr) {
      if (!arr || arr.length === 0) return true;
      return arr.every((item) => Number(item.value || 0) === 0);
    },

    async fetchPaymentData() {
      try {
        this.loading = true;

        const fdRange = this.selectedRange;

        const res = await getPaymentReport(
          this.userId,
          fdRange,
          this.selectedSource,
          this.selectedStatus
        );

        if (res?.status) {

          /* ✅ RESET PAGINATION (CRITICAL FIX) */
          this.page = 1;

          /* ✅ KPI DATA */
          this.kpis = [
            {
              label: "Total Revenue",
              value: `$${res.report_dt.total_revenue || 0}`,
              icon: "bx bx-wallet",
            },
            {
              label: "Completed Payments",
              value: res.report_dt.completed_count || 0,
              icon: "bx bx-check-circle",
            },
            {
              label: "Pending Payments",
              value: res.report_dt.pending_count || 0,
              icon: "bx bx-time-five",
            },
            {
              label: "Refunds",
              value: res.report_dt.refund_count || 0,
              icon: "bx bx-refresh",
            },
          ];

          /* ✅ STABLE CHART DATA (NO OBJECT OVERWRITE BUG) */

          this.chartData.revenue = res.report_dt.revenue_trend || [];
          this.chartData.sources = res.report_dt.sources || [];
          this.chartData.status = res.report_dt.status_breakdown || [];
          this.chartData.trend = res.report_dt.weekly_comparison || [];

          /* ✅ EMPTY DETECTION FIX */

          this.chartData.isRevenue = !this.isEmptyOrZero(this.chartData.revenue);
          this.chartData.isSource = !this.isEmptyOrZero(this.chartData.sources);
          this.chartData.isStatus = !this.isEmptyOrZero(this.chartData.status);
          this.chartData.istrend = !this.isEmptyOrZero(this.chartData.trend);

          /* ✅ TRANSACTIONS */

          this.transactions = res.report_dt.transactions || [];

          /* ✅ RENDER CHARTS SAFELY */

          this.$nextTick(() => {
            if (
              this.chartData.isRevenue ||
              this.chartData.isSource ||
              this.chartData.isStatus ||
              this.chartData.istrend
            ) {
              this.renderCharts();
            }
          });

        } else {

          this.toast.error(res.success || "No data found");

          this.kpis = [];
          this.transactions = [];

          this.chartData.revenue = [];
          this.chartData.sources = [];
          this.chartData.status = [];
          this.chartData.trend = [];

          this.chartData.isRevenue = false;
          this.chartData.isSource = false;
          this.chartData.isStatus = false;
          this.chartData.istrend = false;
        }
      } catch (error) {
        console.error("fetchPaymentData error:", error);
        this.toast.error("Failed to load payment data");
      } finally {
        this.loading = false;
      }
    },

    downPaymentData() {
      try {
        const fdRange = this.selectedRange;

        downPaymentReport(
          this.userId,
          fdRange,
          this.selectedSource,
          this.selectedStatus
        );

      } catch (error) {
        console.error("downPaymentData error:", error);
        this.toast.error("Download failed");
      }
    },

    renderCharts() {
      try {

        document.querySelectorAll(".apexcharts-canvas").forEach((el) => el.remove());

        /* ✅ Revenue Chart */
        if (this.chartData.isRevenue) {

          const revTrend = this.chartData.revenue.map((r) => r.value || 0);
          const revDates = this.chartData.revenue.map((r) => r.date || "");

          new ApexCharts(document.querySelector("#revenueChart"), {
            chart: {
              type: "line",
              height: 200,
              toolbar: { show: false },
              zoom: { enabled: false },
            },
            colors: [CHART_COLORS.primary],
            series: [
              {
                name: "Revenue",
                data: revTrend,
              },
            ],
            xaxis: {
              categories: revDates,
              labels: { style: { colors: CHART_COLORS.muted, fontSize: "12px" } },
            },
            yaxis: {
              labels: { style: { colors: CHART_COLORS.muted, fontSize: "12px" } },
            },
            stroke: {
              curve: "smooth",
              width: 3,
            },
            grid: {
              borderColor: "#E5E7EB",
              strokeDashArray: 4,
            },
            markers: {
              size: 4,
              colors: [CHART_COLORS.primary],
              strokeWidth: 2,
              strokeColors: "#fff",
            },
            tooltip: {
              theme: "light",
            },
          }).render();
        }

        /* ✅ Source Chart */
        if (this.chartData.isSource) {

          const sourceNames = this.chartData.sources.map((s) => s.name || "Unknown");
          const sourceValues = this.chartData.sources.map((s) => s.value || 0);

          new ApexCharts(document.querySelector("#sourceChart"), {
            chart: {
              type: "donut",
              height: 200,
            },
            labels: sourceNames,
            series: sourceValues,
            colors: [
              CHART_COLORS.primary,
              CHART_COLORS.secondary,
              CHART_COLORS.tertiary,
              CHART_COLORS.muted,
            ],
            legend: {
              position: "bottom",
              fontSize: "12px",
              labels: { colors: CHART_COLORS.muted },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              width: 0,
            },
          }).render();
        }

        /* ✅ Status Chart */
        if (this.chartData.isStatus) {

          const statusLabels = this.chartData.status.map((s) => s.name || "");
          const statusValues = this.chartData.status.map((s) => s.value || 0);

         new ApexCharts(document.querySelector("#statusChart"), {
  chart: {
    type: "bar",
    height: 200,
    toolbar: { show: false },
  },
  colors: [CHART_COLORS.primary],
  series: [
    {
      name: "Payments",
      data: statusValues,
    },
  ],
  xaxis: {
    categories: statusLabels,
    labels: { style: { colors: CHART_COLORS.muted, fontSize: "12px" } },
  },
  yaxis: {
    labels: { style: { colors: CHART_COLORS.muted, fontSize: "12px" } },
  },
  plotOptions: {
    bar: {
      borderRadius: 6,
      columnWidth: "40%",
    },
  },
  grid: {
    borderColor: "#E5E7EB",
    strokeDashArray: 4,
  },
}).render();  
        }

        /* ✅ Trend Chart */
        if (this.chartData.istrend) {

          const trendWeeks = this.chartData.trend.map((t) => t.week || "");
          const trendValues = this.chartData.trend.map((t) => t.value || 0);

          new ApexCharts(document.querySelector("#trendChart"), {
  chart: {
    type: "area",
    height: 200,
    toolbar: { show: false },
  },
  colors: [CHART_COLORS.secondary],
  series: [
    {
      name: "AI Trend",
      data: trendValues,
    },
  ],
  xaxis: {
    categories: trendWeeks,
    labels: { style: { colors: CHART_COLORS.muted, fontSize: "12px" } },
  },
  yaxis: {
    labels: { style: { colors: CHART_COLORS.muted, fontSize: "12px" } },
  },
  stroke: {
    curve: "smooth",
    width: 3,
  },
  fill: {
    type: "gradient",
    gradient: {
      shade: "dark",
      gradientToColors: [CHART_COLORS.tertiary],
      opacityFrom: 0.8,
      opacityTo: 0.3,
      stops: [0, 100],
    },
  },
  grid: {
    borderColor: "#E5E7EB",
    strokeDashArray: 4,
  },
}).render();
        }

      } catch (err) {
        console.error("renderCharts error:", err);
      }
    },
  },
};
</script>

<style scoped>
/* === KPI CARDS === */
.kpi-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 20px;
  width: 100%;
}
.kpi-card {
  flex: 1;
  min-width: 220px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}
.kpi-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}
.kpi-card h4 {
  margin: 0;
  font-size: 14px;
  color: var(--muted);
  font-weight: 500;
}
.kpi-card .value {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--text);
}
.kpi-icon {
  font-size: 1.6rem;
  color: var(--primary);
  opacity: 0.9;
}

/* === CTA CARD === */
.cta-card {
  grid-column: span 12 / span 12;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  background: linear-gradient(135deg, #111827, #1f2937, #374151);
  position: relative;
  padding: 2rem 2.5rem;
  margin-bottom: 1.5rem;
  color: #f9fafb;
  cursor: pointer;
  transition: all 0.4s ease;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.25);
}
.cta-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);
}
.cta-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.5rem;
}
.cta-text h2 {
  font-size: 1.6rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 0.4rem;
}
.cta-text p {
  color: #d1d5db;
  font-size: 0.95rem;
  max-width: 540px;
  line-height: 1.6;
}
.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #ffffff;
  color: #111827;
  border: none;
  padding: 10px 18px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(255, 255, 255, 0.15);
}
.cta-btn:hover {
  background: #ffffff;
  transform: translateY(-2px);
}
.cta-btn i {
  font-size: 1.1rem;
}

/* === CHART BOXES === */
.charts-row {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: stretch;
  width: 100%;
  margin-bottom: 1.5rem;
}
.chart-box {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  padding: 16px;
  transition: all 0.3s ease;
}
.chart-box h4 {
  font-size: 14px;
  color: var(--text);
  margin-bottom: 8px;
}
.chart-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #ffffff, #ffffff);
  height: 180px;
  border-radius: 6px;
  color: var(--primary);
  font-weight: 600;
}

/* === TABLE SECTION === */
.table-box {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 16px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  margin-top: 24px;
  transition: all 0.3s ease;
}
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.table-header h4 {
  font-size: 14px;
  color: var(--text);
  font-weight: 600;
  margin: 0;
}
.table-box table {
  width: 100%;
  border-collapse: collapse;
}
.table-box th,
.table-box td {
  padding: 10px;
  border-bottom: 1px solid var(--border);
  text-align: left;
  font-size: 0.9rem;
  color: var(--text);
}
.table-box th {
  background: #f9fafb;
  color: var(--muted);
  font-weight: 600;
}
.table-box tr:hover {
  background: #f9fafb;
  transition: background 0.3s ease;
}
.status {
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 600;
}
.status.completed {
  background: #dcfce7;
  color: #15803d;
}
.status.pending {
  background: #fef3c7;
  color: #92400e;
}

/* === PAGINATION === */
.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 14px;
}
.pagination button {
  border: none;
  background: #ffffff;
  color: var(--text);
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.pagination button:hover:not(:disabled) {
  background: var(--primary);
  color: #fff;
}
.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* === ANIMATIONS === */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes slideUp {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}
/* === 📱 PAYMENT DASHBOARD MOBILE PATCH === */
@media (max-width: 1200px) {
  .charts-row {
    flex-direction: column !important;
    gap: 1.2rem !important;
  }

  .chart-box {
    width: 100% !important;
    flex: 1 1 100% !important;
  }
}

@media (max-width: 992px) {
  .header-row {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 1rem !important;
  }

  .filters {
    width: 100% !important;
    flex-wrap: wrap !important;
    gap: 0.8rem !important;
  }

  .filters select,
  .filters .btn-primary {
    flex: 1 1 calc(50% - 0.5rem) !important;
    min-width: 48% !important;
  }

  .filters .btn-primary {
    justify-content: center !important;
  }

  .page-title {
    font-size: 1.1rem !important;
  }

  .kpi-row {
    flex-wrap: wrap !important;
    gap: 1rem !important;
  }

  .kpi-card {
    flex: 1 1 48% !important;
    min-width: 45% !important;
    padding: 1rem !important;
  }

  .cta-card {
    padding: 1.5rem !important;
    text-align: center !important;
  }

  .cta-content {
    flex-direction: column !important;
    align-items: center !important;
    text-align: center !important;
  }

  .cta-text h2 {
    font-size: 1.3rem !important;
  }

  .cta-text p {
    font-size: 0.9rem !important;
    max-width: 100% !important;
  }

  .cta-btn {
    width: 100% !important;
    justify-content: center !important;
  }

  .charts-row {
    flex-direction: column !important;
    gap: 1.2rem !important;
  }

  .chart-box {
    flex: 1 1 100% !important;
    width: 100% !important;
  }

  .chart-placeholder {
    height: 220px !important;
  }

  .table-box {
    padding: 1rem !important;
    overflow-x: auto !important;
  }

  .table-box table {
    min-width: 650px !important;
  }

  .table-header {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 0.6rem !important;
  }

  .table-header h4 {
    font-size: 0.95rem !important;
  }

  .pagination {
    flex-direction: column !important;
    align-items: center !important;
    gap: 0.8rem !important;
  }

  .pagination button {
    min-width: 38px !important;
    height: 38px !important;
  }
}

@media (max-width: 600px) {
  .filters {
    flex-direction: column !important;
  }

  .filters select,
  .filters .btn-primary {
    width: 100% !important;
  }

  .kpi-card {
    flex: 1 1 100% !important;
    min-width: 100% !important;
  }

  .cta-card {
    padding: 1.2rem !important;
    border-radius: 0.8rem !important;
  }

  .cta-text h2 {
    font-size: 1.15rem !important;
  }

  .cta-text p {
    font-size: 0.85rem !important;
  }

  .cta-btn {
    font-size: 0.9rem !important;
    padding: 0.8rem 1rem !important;
  }

  .chart-box {
    padding: 1rem !important;
  }

  .chart-placeholder {
    height: 200px !important;
  }

  .table-box {
    font-size: 0.85rem !important;
  }

  .table-header select {
    width: 100% !important;
  }

  .pagination span {
    font-size: 0.85rem !important;
  }
}

@media (max-width: 420px) {
  .header-row {
    margin: 0 0 1rem 0 !important;
  }

  .page-title {
    font-size: 1rem !important;
  }

  .filters {
    gap: 0.6rem !important;
  }

  .cta-text h2 {
    font-size: 1rem !important;
  }

  .cta-btn {
    font-size: 0.85rem !important;
  }

  .kpi-card .value {
    font-size: 1.1rem !important;
  }

  .chart-placeholder {
    height: 180px !important;
  }

  .table-box {
    padding: 0.8rem !important;
  }

  .table-box th,
  .table-box td {
    padding: 8px !important;
    font-size: 0.8rem !important;
  }
}
/* ===================== ⚡ PAYMENT DASHBOARD PATCH ===================== */

/* 🔹 Loader Overlay */
.global-loader {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(3px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeIn 0.4s ease;
}
.loader-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #ddd;
  border-top: 4px solid #111827;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
.global-loader p {
  margin-top: 10px;
  font-size: 14px;
  color: #374151;
  font-weight: 500;
}

/* 🔹 Placeholder for empty charts */
.chart-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #fafafa, #fff);
  border: 1px dashed #e5e7eb;
  height: 200px;
  border-radius: 8px;
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
  animation: fadeIn 0.6s ease both;
}

/* Add soft hover pulse when empty */
.chart-placeholder:hover {
  background: linear-gradient(145deg, #f3f4f6, #fff);
  color: #111827;
  transition: all 0.3s ease;
}

/* Empty chart creative icons */
.chart-placeholder::before {
  content: "";
  font-size: 1.8rem;
  margin-right: 6px;
}

/* 🔹 Empty Transaction State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  border: 1px dashed #d1d5db;
  border-radius: 12px;
  background: #fafafa;
  margin-top: 20px;
  animation: fadeIn 0.5s ease both;
}
.empty-state i {
  font-size: 2.4rem;
  color: var(--primary);
  margin-bottom: 10px;
}
.empty-state h3 {
  font-weight: 600;
  font-size: 1.1rem;
  color: #111827;
}
.empty-state p {
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 12px;
}

/* 🔹 Soft fade + spin animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* 🔹 Mobile fix for small viewports */
@media (max-width: 768px) {
  .chart-placeholder {
    height: 180px !important;
    font-size: 13px;
  }
  .empty-state {
    padding: 40px 10px;
  }
}

/* 🔹 KPI Card subtle hover pulse */
.kpi-card {
  transition: all 0.3s ease;
}
.kpi-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}
.empty-state {
  text-align: center;
  padding: 50px 20px;
  border: 1px dashed #d1d5db;
  border-radius: 12px;
  background: #fafafa;
  animation: fadeIn 0.4s ease both;
}

.empty-state i {
  font-size: 2rem;
  color: var(--primary);
  margin-bottom: 8px;
}

.empty-state h3 {
  margin-bottom: 6px;
  color: #111827;
  font-weight: 600;
}

.empty-state p {
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 10px;
}

/* ===============================
 EMPTY CHART PLACEHOLDER
=============================== */

.empty-chart-placeholder {
  height: 200px;
  border-radius: 10px;
  border: 1px dashed var(--border);
  background: linear-gradient(145deg, #fafafa, #ffffff);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: var(--muted);
  font-size: 13px;
  text-align: center;
  transition: all 0.3s ease;
}

.empty-chart-placeholder i {
  font-size: 26px;
  color: var(--primary);
  opacity: 0.7;
}

.empty-chart-placeholder p {
  margin: 0;
  font-size: 13px;
  color: var(--muted);
}

/* subtle hover polish */

.empty-chart-placeholder:hover {
  background: #f9fafb;
  transform: translateY(-1px);
}

/* ===============================
 BUTTON SYSTEM (GLOBAL CONSISTENCY)
=============================== */

.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--primary);
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.btn-primary:active {
  transform: scale(0.97);
}

/* ===============================
 SELECT SYSTEM (REMOVE INLINE STYLES)
=============================== */

.select-theme {
  padding: 8px 12px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--card);
  color: var(--text);
  font-size: 13px;
  min-width: 140px;
  cursor: pointer;
  transition: all 0.25s ease;
}

.select-theme:hover {
  border-color: var(--primary);
}

.select-theme:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 2px rgba(17, 24, 39, 0.08);
}

/* ===============================
 TABLE STATUS POLISH
=============================== */

.table-box td span {
  font-weight: 600;
}

/* ===============================
 CHART CONTAINER STABILITY
=============================== */

.chart-placeholder {
  min-height: 200px;
}

/* ===============================
 SMALL SCREEN POLISH
=============================== */

@media (max-width: 768px) {

  .empty-chart-placeholder {
    height: 180px;
  }

  .btn-primary {
    width: 100%;
    justify-content: center;
  }

}
</style>